import i18next from 'i18next';
import ROUTES from '~constants/routes';
// import { createSearchUrl } from '~utils/search';

export interface NavbarItem {
  name: string;
  to: string | { pathname: string; hash: string };
  exact?: boolean;
  regexp?: RegExp;
}

export const IIRSA_ITEMS = [
  {
    name: i18next.t('navbar:home'),
    pathname: '/home',
    hash: '',
    iconName: 'home'
  },
  {
    name: i18next.t('navbar:projects'),
    pathname: '/projects',
    hash: '',
    iconName: 'projects'
  },
  {
    name: i18next.t('navbar:routes'),
    pathname: '/routes',
    hash: '',
    iconName: 'road'
  },
  {
    name: i18next.t('navbar:maps'),
    pathname: '/routes/map',
    hash: '',
    iconName: 'map'
  },
  {
    name: i18next.t('navbar:charts'),
    pathname: '/routes/charts',
    hash: '',
    iconName: 'charts'
  },
  // {
  //   name: i18next.t('navbar:projects'),
  //   pathname: '/projects',
  //   hash: ''
  // },
  // {
  //   name: i18next.t('navbar:projectCharts'),
  //   pathname: '/project-charts',
  //   hash: ''
  // }
];
